import React from 'react';
import './AboutUsMisyon.css';
import misyon from "../../../assets/images/misyon.jpg";

const AboutUsMisyon = () => {
  return (
    <section className="misyonumuz-section">
      <div className="misyonumuz-container">
        <div className="misyonumuz-text">
          <p className="misyonumuz-baslik">Misyonumuz</p>
          <p className="misyonumuz-metin">
            Lingify olarak, iletişim kurma hakkının herkes için erişilebilir olması gerektiğine inanıyoruz.
            Konuşma ve dil bozuklukları yaşayan bireylerin yaşam kalitesini artırmak amacıyla, bilim temelli
            ve yapay zeka destekli dijital sağlık çözümleri geliştiriyoruz. Hedefimiz; terapiyi zaman, mekân
            ve sosyoekonomik koşullardan bağımsız hale getirerek bireylere ve uzmanlara kişiselleştirilmiş,
            güvenilir ve sürdürülebilir destek sunmak.
          </p>
        </div>
        <div className="misyonumuz-image">
          <img src={misyon} alt="Misyonumuz" />
        </div>
      </div>
    </section>
  );
};

export default AboutUsMisyon;
